import axios from 'axios';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import React from 'react';
import './index.css';

axios.defaults.baseURL = import.meta.env.VITE_BASE_API;
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
